'use client'

import { useBreakpointValue } from '@chakra-ui/react'
import { IRedux } from '@/app/[locale]/_store/types'
import { useDispatch, useSelector } from 'react-redux'
import { onCloseMap } from '@/app/[locale]/_store/common/common.slice'
import dynamic from 'next/dynamic'

const Desktop = dynamic(() => import('./desktop'), { ssr: false })
const Mobile = dynamic(() => import('./mobile'), { ssr: false })

const Map = () => {
  const dispatch = useDispatch()
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  const { is_hall } = useSelector((state: IRedux) => state.session)
  const { isMapModal } = useSelector((state: IRedux) => state.common)

  if (is_hall === 'true' || !isMapModal) {
    return null
  }

  const commonProps = {
    open: isMapModal,
    onClose: () => dispatch(onCloseMap()),
  }

  if (isDesktop) return <Desktop {...commonProps} />

  return <Mobile {...commonProps} />
}

export default Map
